
import { Vue, Component } from "vue-property-decorator";
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
    })
  }
})
export default class vBreadcrumbs extends Vue {
  localizationState: any;

  get translations() {
    return this.localizationState.translations;
  }
}
